<template>
    <div class="messenger-page-selector">
        <div class="page-card">
            <div class="page-card-header">
                <div class="page-card-header-title">Select a Messenger Account</div>
            </div>
            <div class="page-card-body">
                <div class="page-card-body-content">
                    <div class="page-card-body-content-item" v-for="page in getMessengerPages()" :key="page.id">
                        <div class="page-card-body-content-item-image">
                            <img :src="page.picture.data.url" alt="page image" />
                        </div>
                        <div class="page-card-body-content-item-info">
                            <div class="page-card-body-content-item-info-name">
                                {{ page.name }}
                            </div>
                            <div class="page-card-body-content-item-info-username">
                                {{ page.username }}
                            </div>
                        </div>
                        <div class="page-card-body-content-item-action">
                            <a-button type="primary" @click="() => changeValue(page)"> Select</a-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import Vue from "vue";
import _ from "lodash";

export default Vue.extend({
    name: "MessengerPageSelector",
    props: {
        pages: {
            type: Array,
            required: true,
        },
        value: String,
    },
    data() {
        return {
            clone: _.cloneDeep(this.value),
        };
    },
    methods: {
        getMessengerPages() {
            return this.pages;
        },
        changeValue(page) {
            this.clone = page;
        },
    },
    created() {
        this.clone = _.cloneDeep(this.value);
    },
    watch: {
        value: {
            deep: true,
            handler(value) {
                if (_.isEqual(value, this.clone)) return;
                this.clone = _.cloneDeep(value);
            },
        },
        clone: {
            deep: true,
            handler(value) {
                this.$emit("input", value);
            },
        },
    },
});
</script>

<style scoped lang="scss">
.messenger-page-selector {
    .page-card {
        border-radius: 8px;
        overflow: hidden;

        .page-card-header {
            background-color: #f5f5f5;
            padding: 16px;

            .page-card-header-title {
                font-size: 18px;
                font-weight: 500;
            }
        }

        .page-card-body {
            .page-card-body-content {
                display: grid;
                grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
                gap: 16px;
                padding: 16px;

                .page-card-body-content-item {
                    background-color: #fff;
                    border-radius: 8px;
                    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
                    display: flex;
                    padding: 16px;

                    .page-card-body-content-item-image {
                        flex: 0 0 80px;

                        img {
                            border-radius: 50%;
                            height: 80px;
                            width: 80px;
                        }
                    }

                    .page-card-body-content-item-info {
                        flex: 1;
                        padding: 0 16px;

                        .page-card-body-content-item-info-name {
                            font-size: 16px;
                            font-weight: 500;
                        }

                        .page-card-body-content-item-info-username {
                            color: #666;
                            font-size: 14px;
                        }
                    }

                    .page-card-body-content-item-action {
                        flex: 0 0 100px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }
                }
            }
        }
    }
}
</style>
